// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const id: ChromeTranslations = {
  'nav.nextPage': 'halaman berikutnya →',
  'nav.previousPage': '← halaman sebelumnya',
  'nav.continueToLevel': 'lanjut ke level →',
  'nav.backToMenu': 'kembali ke menu →',
  'howto.page': 'halaman {n} dari {total}',
  'options.title': 'Opsi',
  'ui.language': 'Bahasa',
};
